import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/base/SEOHead';
import ScrollToTop from '@/components/base/ScrollToTop';
import HeroSection from './components/HeroSection';
import ProfileSection from './components/ProfileSection';
import WorksSection from './components/WorksSection';
import NewsSection from './components/NewsSection';
import FAQSection from './components/FAQSection';
import CommunitySection from './components/CommunitySection';
import { siteInfo, faqData } from '@/mocks/home';

const homeSchema = [
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '水野朝阳官方粉丝站',
    url: siteInfo.url,
    description: siteInfo.description,
    foundingDate: '2024',
    contactPoint: {
      '@type': 'ContactPoint',
      email: 'contact@zhangzaichao.cn',
      contactType: 'customer service',
    },
    sameAs: [
      'https://twitter.com/mizuno_asahi',
      'https://instagram.com/mizuno_asahi',
    ],
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '水野朝阳官方粉丝站',
    url: siteInfo.url,
    description: siteInfo.description,
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: `${siteInfo.url}/category/all?q={search_term_string}`,
      },
      'query-input': 'required name=search_term_string',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '水野朝阳 - 官方粉丝落地页',
    description: siteInfo.description,
    url: siteInfo.url,
    isPartOf: {
      '@type': 'WebSite',
      name: '水野朝阳官方粉丝站',
      url: siteInfo.url,
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqData.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  },
];

export default function Home() {
  return (
    <>
      <SEOHead
        title="水野朝阳 - 官方粉丝落地页"
        description={siteInfo.description}
        keywords={siteInfo.keywords}
        canonicalPath="/"
        ogType="website"
        ogImage="https://readdy.ai/api/search-image?query=Elegant%20Japanese%20celebrity%20fan%20site%20branding%2C%20warm%20golden%20lighting%2C%20sophisticated%20atmosphere%2C%20cinematic%20style%2C%20professional%20photography&width=1200&height=630&seq=mizuno-og-home&orientation=landscape"
        schema={homeSchema}
      />
      <ScrollToTop />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main>
          <HeroSection />
          <ProfileSection />
          <WorksSection />
          <NewsSection />
          <FAQSection />
          <CommunitySection />
        </main>

        <Footer />
      </div>
    </>
  );
}